import { render, staticRenderFns } from "./CoursesViewTabGral.vue?vue&type=template&id=3a4de6f6"
import script from "./CoursesViewTabGral.vue?vue&type=script&lang=js"
export * from "./CoursesViewTabGral.vue?vue&type=script&lang=js"
import style0 from "./CoursesViewTabGral.vue?vue&type=style&index=0&id=3a4de6f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports